import { ACKStatusEnum } from 'order/wizard/orderAcknowledgement/enums/ACKStatusEnum';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Step, Stepper, StepperList } from 'shared/components/Stepper';
import { Wrapper } from 'shared/components/Wrapper';
import { RootState } from 'store';
import styled from 'styled-components';

const StepperContainer = styled(Wrapper)`
  left: 0;
  padding: 7px 0;
  position: fixed;
  right: 0;
  top: 152px;
`;

const StepperListStyled = styled(StepperList)`
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  padding: 16px 0px;
  background-color: ${({ theme }) => theme.white};
  border-bottom: 1px solid ${({ theme }) => theme.alto};
  z-index: 1;
`;

export const OrderLevelStepper = () => {
  const latestACK = useSelector(
    (state: RootState) => state.ACKReducer.latestACK
  );
  const currentOrder = useSelector(
    (state: RootState) => state.orderReducer.order
  );
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  useEffect(() => {
    switch (true) {
      case !latestACK:
        setSelectedIndex(0);
        break;
      case latestACK?.status === ACKStatusEnum.PENDING &&
        (latestACK?.version ?? 0) === 1:
        setSelectedIndex(0);
        break;
      case latestACK?.status === ACKStatusEnum.CHANGES_REQUESTED:
        setSelectedIndex(1);
        break;
      case latestACK?.status === ACKStatusEnum.FINISHED_REQUESTING_CHANGES:
        setSelectedIndex(3);
        break;
      case latestACK?.status === ACKStatusEnum.PENDING &&
        (latestACK?.version ?? 0) > 1:
        setSelectedIndex(4);
        break;
      default:
        setSelectedIndex(0);
    }
  }, [latestACK, currentOrder]);

  return (latestACK?.status ?? 0) > 1 || (latestACK?.version ?? 0) >= 2 ? (
    <StepperContainer>
      <Stepper selectedIndex={selectedIndex}>
        <StepperListStyled>
          <Step readOnly className="step-checked">
            Review Acknowledgment
          </Step>
          <Step readOnly className={selectedIndex >= 2 ? 'step-checked' : ''}>
            Request Changes
          </Step>
          <Step readOnly className={selectedIndex >= 3 ? 'step-checked' : ''}>
            Finish Request
          </Step>
          <Step readOnly className={selectedIndex >= 4 ? 'step-checked' : ''}>
            CSR Makes Changes
          </Step>
          <Step readOnly>Review Changes</Step>
          <Step readOnly lastChildMargin={14}>
            Approve Acknowledgment
          </Step>
        </StepperListStyled>
      </Stepper>
    </StepperContainer>
  ) : (
    <StepperContainer>
      <Stepper selectedIndex={selectedIndex}>
        <StepperListStyled>
          <Step readOnly lineWidth={50}>
            Review Acknowledgment
          </Step>
          <Step readOnly>Request Changes or Approve Acknowledgment</Step>
        </StepperListStyled>
      </Stepper>
    </StepperContainer>
  );
};
